import React, { useState } from 'react';
import WageDeductionSC from './wage-deduction.styled';
import Button from '../../ui/button';
import { BiggerText, SmallText } from '../../typography';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import DocumentsVerification from '../documents-verification';

const WageDeduction = ({ onClick, documents, disabled }) => {
  const [areAllRead, setAllRead] = useState(false);
  const setDocumentsToAllRead = (status) => {
    setAllRead(status);
  };

  return (
    <WageDeductionSC>
      <DocumentsVerification
        documents={documents}
        setDocumentsToAllRead={(status) => setDocumentsToAllRead(status)}
      />
      <div className="bottom-wrap">
        <BiggerText>
          <FormattedHTMLMessage
            id="onboarding_sign_hint"
            defaultMessage={dlt['onboarding_sign_hint']}
          />
        </BiggerText>

        <div className="half-wrap">
          <Button
            type="PRIMARY"
            disabled={areAllRead ? false : true}
            onClick={() => onClick('accepted')}
          >
            <FormattedMessage id="global_sign" defaultMessage={dlt['global_sign']} />
          </Button>
          <Button
            type="OUTLINED"
            size="BIG"
            onClick={() => onClick('declined')}
            disabled={areAllRead && !disabled ? false : true}
          >
            <FormattedMessage id="global_do_not_sign" defaultMessage={dlt['global_do_not_sign']} />
          </Button>
        </div>

        <SmallText className="black-transparent">
          <FormattedMessage
            id="onboarding_documents_hint"
            defaultMessage={dlt['onboarding_documents_hint']}
          />
        </SmallText>
      </div>
    </WageDeductionSC>
  );
};

export default WageDeduction;
